import { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is the Wise Check?',
      answer: 'The Wise Check is our free business diagnostic tool that identifies constraints in your business across marketing, sales, operations, finances, and team capacity. It provides a comprehensive analysis to help you understand where to focus your efforts.'
    },
    {
      question: 'How long does a strategy session take?',
      answer: 'Our complimentary initial strategy session typically lasts 45-60 minutes. We discuss your Wise Check results, explore your business goals, and outline potential solutions tailored to your specific needs.'
    },
    {
      question: 'Do you work with businesses outside Central Queensland?',
      answer: 'While we\'re based in Central Queensland and specialize in regional Australian businesses, we work with clients across Australia through virtual consultations and on-site visits when needed.'
    },
    {
      question: 'What makes Mediawise Solutions different?',
      answer: 'We don\'t just provide marketing advice—we combine strategic marketing with business systems optimization. We focus on the root causes of business constraints, not just surface symptoms, ensuring sustainable growth.'
    },
    {
      question: 'What happens after I complete the Wise Check?',
      answer: 'You\'ll receive a summary of your results immediately. The full detailed analysis is sent to our team, and we\'ll reach out to discuss your results and how we can help. You can also book a strategy session directly.'
    },
    {
      question: 'What services do you offer?',
      answer: 'We provide business strategy development, marketing consulting, business systems optimization, process documentation, CRM implementation, and ongoing strategic support tailored to regional businesses.'
    },
    {
      question: 'How much do your services cost?',
      answer: 'Our pricing is customized based on your specific needs and goals. During the strategy session, we\'ll discuss your situation and provide transparent pricing options. The initial Wise Check and strategy session are complimentary.'
    },
    {
      question: 'How quickly can I expect results?',
      answer: 'It depends on your specific constraints and goals. Some optimizations show immediate results, while systemic changes take 90-180 days. We provide realistic timelines during your strategy session.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="gradient-line mx-auto"></div>
        </div>

        <div className="faq-list" data-testid="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item" data-testid={`faq-item-${index}`}>
              <button
                onClick={() => toggleFAQ(index)}
                className="faq-question"
                data-testid={`faq-question-${index}`}
              >
                <span>{faq.question}</span>
                {openIndex === index ? <FiChevronUp /> : <FiChevronDown />}
              </button>
              {openIndex === index && (
                <div className="faq-answer" data-testid={`faq-answer-${index}`}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;